/* import __COLOCATED_TEMPLATE__ from './warm-transfer-countdown.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { registerDestructor } from '@ember/destroyable';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Signature {
  Args: {
    startedAt?: number;
    timeoutSeconds?: number;
  };
  Element: HTMLSpanElement;
}

export default class WarmTransferCountdown extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked currentTime = Date.now();

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);

    let timer = setInterval(() => (this.currentTime = Date.now()), 1000);

    registerDestructor(this, () => {
      clearInterval(timer);
    });
  }

  get remainingSeconds(): number {
    if (!this.args.startedAt || !this.args.timeoutSeconds) {
      return 0;
    }

    let elapsedMs = this.currentTime - this.args.startedAt;
    let elapsedSeconds = Math.floor(elapsedMs / 1000);
    let remaining = this.args.timeoutSeconds - elapsedSeconds;

    return Math.max(0, remaining);
  }

  get formattedTime(): string {
    return this.intl.t('calling.modal.warm-transfer-team.countdown', {
      seconds: this.remainingSeconds,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::WarmTransferCountdown': typeof WarmTransferCountdown;
    'inbox2/calling/warm-transfer-countdown': typeof WarmTransferCountdown;
  }
}
